import fs from 'fs-extra'
import path from 'path'

import { AddOptions } from '@commands/add'
import { txt } from '@utils/colors'
import { getConfig } from '@utils/getConfig'

export const preflightAdd = async (options: AddOptions) => {
  if (!fs.existsSync(options.cwd) || !fs.existsSync(path.resolve(options.cwd, 'package.json'))) {
    return {
      config: null,
    }
  }

  if (!fs.existsSync(path.resolve(options.cwd, 'components.json'))) {
    throw new Error(
      `The components.json file is missing. Run the following command to set up your project:\n\n${txt.info('npx radianos init')}`
    )
  }

  try {
    const config = await getConfig(options.cwd)
    return config!
  } catch (error) {
    throw new Error(
      `An invalid ${txt.info('components.json')} file was found at ${txt.info(options.cwd)}.
            \nBefore you can add components, you must create a valid ${txt.info('components.json')} file by running the ${txt.info('init')} command.`
    )
  }
}
